import { Checkbox } from "../../Checkbox"
import { IResponsiveWrap } from "../../../../../base/styles"
import { SelectWrap } from "./SelectWrap"
import clsx from "clsx"
import { useState } from "react"

export const EditWrap = ({ title, value, className, onChange }: {
    title: string,
    value: IResponsiveWrap,
    className?: string,
    onChange: (value?: IResponsiveWrap) => void
}) => {
    const [responsive, setResponsive] = useState<boolean>();

    return (
        <div className={clsx(className)}>
            <div className="d-flex align-items-end">
                <SelectWrap
                    title={title}
                    className="flex-grow-1 me-2"
                    onChange={(newValue) => { onChange({ ...value, allSizes: newValue }) }}
                    value={value.allSizes} />
                <Checkbox
                    title="Responsive"
                    className="fs-8 fw-semibold"
                    value={responsive === true}
                    onChange={setResponsive} />
            </div>

            {responsive &&
                <div className="d-flex flex-row flex-wrap mx-5 my-3">
                    <SelectWrap
                        title="Small"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, small: newValue }) }}
                        value={value?.small} />
                    <SelectWrap
                        title="Medium"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, medium: newValue }) }}
                        value={value?.medium} />
                    <SelectWrap
                        title="Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, large: newValue }) }}
                        value={value?.large} />
                    <SelectWrap
                        title="Ex. Large"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xLarge: newValue }) }}
                        value={value?.xLarge} />
                    <SelectWrap
                        title="Ex. Large +"
                        className="w-50 pe-2"
                        onChange={(newValue) => { onChange({ ...value, xxLarge: newValue }) }}
                        value={value?.xxLarge} />
                </div>}
        </div>)
}